import { createContext, useContext } from 'react';
import type { MediaNode, MediaType } from 'shared/modelTypes/media';

export const FilePickerContext = createContext<
	| {
			pickFile: (acceptedTypes: MediaType[]) => Promise<MediaNode | null>;
	  }
	| undefined
>(undefined);
export const useFilePickerContext = () => {
	const ctx = useContext(FilePickerContext);
	if (!ctx) {
		throw new Error('useFilePickerContext called outside filePickerContext');
	}
	return ctx;
};
